import React, { Component } from 'react'

import Edit from '../../crud/edit'
import { isNotMultiplierField } from '../multiplier'
import menuItems from './menuItems'
import fields from './fields'
import loadDiscounts from './loadDiscounts'

class EditOrderDiscount extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = { discounts: [] }
  }

  componentDidMount () {
    loadDiscounts(this.props.params.orderId)
      .then(discounts => {
        if (discounts) this.setState({ discounts })
      })
  }

  render () {
    const { orderId, orderDiscountId } = this.props.params
    const { discounts } = this.state

    return (
      <Edit
// @ts-ignore
        title='Edit Order Discount'
        fields={fields(discounts).filter(isNotMultiplierField)}
        apiPath={`admin/order_discounts/${orderDiscountId}`}
        successRedirectPath={`/ecommerce/orders/${orderId}/discounts`}
        buildMenuItems={menuItems}
      />
    )
  }
}

export default EditOrderDiscount
